import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row mb-4" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "card-body py-2 d-flex align-items-center justify-content-between" }
const _hoisted_10 = { class: "badge badge-secondary mx-1" }
const _hoisted_11 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "card mt-3" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "form-row" }
const _hoisted_16 = { class: "form-group col-md-3" }
const _hoisted_17 = { class: "form-group col-md-3" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "form-group col-md-3" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "form-group col-md-2" }
const _hoisted_22 = { class: "row mb-4" }
const _hoisted_23 = { class: "col-12" }
const _hoisted_24 = { class: "card-body py-2 d-flex align-items-center justify-content-between" }
const _hoisted_25 = { class: "badge badge-secondary mx-1" }
const _hoisted_26 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "card mt-3" }
const _hoisted_29 = { class: "card-body" }
const _hoisted_30 = { class: "form-row" }
const _hoisted_31 = { class: "form-group col-md-3" }
const _hoisted_32 = { class: "form-group col-md-3" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "form-group col-md-3" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "form-group col-md-2" }

import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelineItemFiltersPage } from '@Integrations/Pipelines/pages-core'

    const valuePlaceholder = 'Value or {{UserId}}'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminConfigurePipelineItemFiltersPage',
  setup(__props) {

    document.title = "Configure item filters"

    const tid = useOrganizationUnitId()
    const id = useId()

    const {
        useCurrentUserQuery,
        usePipelineDetailsQuery,
        useAddConnectorItemFilterCommand,
     useRemoveConnectorItemFilterCommand,
        useAddDatasetItemFilterCommand,
      useRemoveDatasetItemFilterCommand
    } = useAdminConfigurePipelineItemFiltersPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const connectorItemFilters = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorItemFilters || [])
    const datasetItemFilters = computed(() => modelPipelineDetailsQueryV1.value?.DatasetItemFilters || [])
    const availableFilterOperators = computed(() => modelPipelineDetailsQueryV1.value?.AvailableFilterOperators || [0, 1, 2, 3, 4, 5])

    // Add Connector Item Filter
    const { invokeAddConnectorItemFilterCommandV1, succeedAddConnectorItemFilterCommandV1 } = useAddConnectorItemFilterCommand(id, tid, userId)

    // Remove Connector Item Filter
    const { invokeRemoveConnectorItemFilterCommandV1, succeedRemoveConnectorItemFilterCommandV1 } = useRemoveConnectorItemFilterCommand(id, tid, userId)

    // Add Dataset Item Filter
    const { invokeAddDatasetItemFilterCommandV1, succeedAddDatasetItemFilterCommandV1 } = useAddDatasetItemFilterCommand(id, tid, userId)

    // Remove Dataset Item Filter
    const { invokeRemoveDatasetItemFilterCommandV1, succeedRemoveDatasetItemFilterCommandV1 } = useRemoveDatasetItemFilterCommand(id, tid, userId)

    // New filter forms
    const newConnectorFilter = reactive({
        propertyName: '',
    operator: 0,
  value: '',
        excludeMatching: true
    })

    const newDatasetFilter = reactive({
        propertyName: '',
        operator: 0,
     value: '',
        excludeMatching: true
    })

    const operatorLabels: Record<number, string> = {
0: 'Equals',
 1: 'Not Equals',
      2: 'Contains',
        3: 'Not Contains',
        4: 'Is Empty',
        5: 'Is Not Empty'
    }

    function getOperatorLabel(operator: number): string {
     return operatorLabels[operator] || `Operator ${operator}`
    }

    function isEmptyOperator(operator: number): boolean {
        return operator === 4 || operator === 5
    }

    function handleAddConnectorItemFilter() {
        if (!newConnectorFilter.propertyName) return
        invokeAddConnectorItemFilterCommandV1({
            PropertyName: newConnectorFilter.propertyName,
        Operator: newConnectorFilter.operator,
    Value: isEmptyOperator(newConnectorFilter.operator) ? null : newConnectorFilter.value,
        ExcludeMatching: newConnectorFilter.excludeMatching
        })
    }

    function handleRemoveConnectorItemFilter(filter: any) {
     invokeRemoveConnectorItemFilterCommandV1({
   PropertyName: filter.PropertyName,
 Operator: filter.Operator,
 Value: filter.Value,
        ExcludeMatching: filter.ExcludeMatching
        })
    }

    function handleAddDatasetItemFilter() {
        if (!newDatasetFilter.propertyName) return
        invokeAddDatasetItemFilterCommandV1({
         PropertyName: newDatasetFilter.propertyName,
            Operator: newDatasetFilter.operator,
            Value: isEmptyOperator(newDatasetFilter.operator) ? null : newDatasetFilter.value,
            ExcludeMatching: newDatasetFilter.excludeMatching
        })
    }

    function handleRemoveDatasetItemFilter(filter: any) {
      invokeRemoveDatasetItemFilterCommandV1({
        PropertyName: filter.PropertyName,
  Operator: filter.Operator,
            Value: filter.Value,
            ExcludeMatching: filter.ExcludeMatching
        })
    }

    onMounted(() => {
 runCurrentUserQueryV1()
  runPipelineDetailsQueryV1()
    })

  // Refresh data after commands succeed
    watch([
        succeedAddConnectorItemFilterCommandV1,
 succeedRemoveConnectorItemFilterCommandV1,
  succeedAddDatasetItemFilterCommandV1,
        succeedRemoveDatasetItemFilterCommandV1
    ], () => {
    runPipelineDetailsQueryV1()
        // Reset forms
        newConnectorFilter.propertyName = ''
    newConnectorFilter.value = ''
 newDatasetFilter.propertyName = ''
     newDatasetFilter.value = ''
    })

return (_ctx: any,_cache: any) => {
  const _component_AdminNavigationV2 = _resolveComponent("AdminNavigationV2")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[9] || (_cache[9] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Configure item filters", -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/details/${_unref(tid)}/${_unref(id)}`,
            type: "button",
            class: "btn btn-link btn-sm"
          }, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("i", {
              class: "fa fa-arrow-left",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createElementVNode("span", null, "Back", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_5)
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[31] || (_cache[31] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      _createCommentVNode(" Connector Item Filters "),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[18] || (_cache[18] = _createElementVNode("h5", null, "Connector Item Filters", -1 /* CACHED */)),
          _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-muted small" }, "Filter items from connector data before processing", -1 /* CACHED */)),
          _createCommentVNode(" Existing Filters "),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(connectorItemFilters.value, (filter, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'connector-' + index,
              class: "card mb-2"
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(filter.PropertyName), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(getOperatorLabel(filter.Operator)), 1 /* TEXT */),
                  (filter.Value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "\"" + _toDisplayString(filter.Value) + "\"", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", filter.ExcludeMatching ? 'badge-danger' : 'badge-success'])
                  }, _toDisplayString(filter.ExcludeMatching ? 'Exclude matching' : 'Keep matching only'), 3 /* TEXT, CLASS */)
                ]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (handleRemoveConnectorItemFilter(filter)),
                  class: "btn btn-sm btn-outline-danger"
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("i", {
                    class: "fa fa-trash",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_12)
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _createCommentVNode(" Add New Filter Form "),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[17] || (_cache[17] = _createElementVNode("h6", null, "Add Connector Filter", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", null, "Property Name", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newConnectorFilter.propertyName) = $event)),
                    type: "text",
                    class: "form-control form-control-sm",
                    placeholder: "e.g., Name, Status"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, newConnectorFilter.propertyName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", null, "Operator", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newConnectorFilter.operator) = $event)),
                    class: "form-control form-control-sm"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableFilterOperators.value, (op) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: op,
                        value: op
                      }, _toDisplayString(getOperatorLabel(op)), 9 /* TEXT, PROPS */, _hoisted_18))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, newConnectorFilter.operator]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", null, "Value", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newConnectorFilter.value) = $event)),
                    type: "text",
                    class: "form-control form-control-sm",
                    disabled: isEmptyOperator(newConnectorFilter.operator),
                    placeholder: valuePlaceholder
                  }, null, 8 /* PROPS */, _hoisted_20), [
                    [_vModelText, newConnectorFilter.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", null, "Action", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newConnectorFilter.excludeMatching) = $event)),
                    class: "form-control form-control-sm"
                  }, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("option", { value: true }, "Exclude", -1 /* CACHED */),
                    _createElementVNode("option", { value: false }, "Keep only", -1 /* CACHED */)
                  ]))], 512 /* NEED_PATCH */), [
                    [_vModelSelect, newConnectorFilter.excludeMatching]
                  ])
                ]),
                _createElementVNode("div", { class: "form-group col-md-1 d-flex align-items-end" }, [
                  _createElementVNode("button", {
                    onClick: handleAddConnectorItemFilter,
                    class: "btn btn-sm btn-primary"
                  }, "Add")
                ])
              ])
            ])
          ])
        ])
      ]),
      _cache[29] || (_cache[29] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
      _createCommentVNode(" Dataset Item Filters "),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _cache[27] || (_cache[27] = _createElementVNode("h5", null, "Dataset Item Filters", -1 /* CACHED */)),
          _cache[28] || (_cache[28] = _createElementVNode("p", { class: "text-muted small" }, "Filter items from dataset data before processing", -1 /* CACHED */)),
          _createCommentVNode(" Existing Filters "),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datasetItemFilters.value, (filter, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'dataset-' + index,
              class: "card mb-2"
            }, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(filter.PropertyName), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(getOperatorLabel(filter.Operator)), 1 /* TEXT */),
                  (filter.Value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, "\"" + _toDisplayString(filter.Value) + "\"", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", filter.ExcludeMatching ? 'badge-danger' : 'badge-success'])
                  }, _toDisplayString(filter.ExcludeMatching ? 'Exclude matching' : 'Keep matching only'), 3 /* TEXT, CLASS */)
                ]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (handleRemoveDatasetItemFilter(filter)),
                  class: "btn btn-sm btn-outline-danger"
                }, [...(_cache[20] || (_cache[20] = [
                  _createElementVNode("i", {
                    class: "fa fa-trash",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_27)
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _createCommentVNode(" Add New Filter Form "),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _cache[26] || (_cache[26] = _createElementVNode("h6", null, "Add Dataset Filter", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", null, "Property Name", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newDatasetFilter.propertyName) = $event)),
                    type: "text",
                    class: "form-control form-control-sm",
                    placeholder: "e.g., Name, Status"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, newDatasetFilter.propertyName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", null, "Operator", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newDatasetFilter.operator) = $event)),
                    class: "form-control form-control-sm"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableFilterOperators.value, (op) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: op,
                        value: op
                      }, _toDisplayString(getOperatorLabel(op)), 9 /* TEXT, PROPS */, _hoisted_33))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, newDatasetFilter.operator]
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", null, "Value", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newDatasetFilter.value) = $event)),
                    type: "text",
                    class: "form-control form-control-sm",
                    disabled: isEmptyOperator(newDatasetFilter.operator),
                    placeholder: valuePlaceholder
                  }, null, 8 /* PROPS */, _hoisted_35), [
                    [_vModelText, newDatasetFilter.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", null, "Action", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newDatasetFilter.excludeMatching) = $event)),
                    class: "form-control form-control-sm"
                  }, [...(_cache[24] || (_cache[24] = [
                    _createElementVNode("option", { value: true }, "Exclude", -1 /* CACHED */),
                    _createElementVNode("option", { value: false }, "Keep only", -1 /* CACHED */)
                  ]))], 512 /* NEED_PATCH */), [
                    [_vModelSelect, newDatasetFilter.excludeMatching]
                  ])
                ]),
                _createElementVNode("div", { class: "form-group col-md-1 d-flex align-items-end" }, [
                  _createElementVNode("button", {
                    onClick: handleAddDatasetItemFilter,
                    class: "btn btn-sm btn-primary"
                  }, "Add")
                ])
              ])
            ])
          ])
        ])
      ]),
      _createCommentVNode(" Help Section "),
      _cache[30] || (_cache[30] = _createStaticVNode("<div class=\"row\"><div class=\"col-12\"><div class=\"alert alert-info\"><h6>Filter Value Reference</h6><p class=\"mb-1\">Use <code>{{PipelineId}}</code>, <code>{{RunId}}</code>, <code>{{UserId}}</code>, or <code>{{UserEmail}}</code> for dynamic values.</p><p class=\"mb-0\">Example: Filter items where UserId equals the current user: Property=<code>UserId</code>, Operator=<code>Equals</code>, Value=<code>{{UserId}}</code></p></div></div></div>", 1))
    ])
  ]))
}
}

})